import React, {useState, useEffect} from 'react'; 
import Pagination from 'components/pagination';
import PropTypes from 'prop-types';

function TableWithPagination(props){
    // const [activePage, setActivePage] = useState(1);
    // const [totalItemsCount, setTotalItemsCount] = useState(null);
    // let [itemsPerPage, setItemsPerPage] = useState(10);
    const defaultPaginationConfig = {page:1, totalItemsCount:0, itemsPerPage:10 }
    
    const [paginationConfig, setPaginationConfig] = useState(props.paginationConfig || defaultPaginationConfig);
    
    useEffect(()=>{
        setPaginationConfig({...props.paginationConfig})
    },[props.paginationConfig])

    return(
        <React.Fragment>
            {!props.hideTopPagination && <div className="d-flex justify-content-end ">
                <Pagination totalItems={paginationConfig.totalItemsCount} 
                            itemsPerPage={paginationConfig.itemsPerPage}
                            className="mt-0"
                    // itemsPerPage={parseInt(itemsPerPage || CONST.P_ITEMS_LIMIT)}
                    // activePage={parseInt(activePage || 1)} 
                    activePage={paginationConfig.page} 
                    onPageChange={props.pageChange} />
            </div>}
            {
              props.children   
            }
            <div className="d-flex justify-content-end ">
                <Pagination totalItems={paginationConfig.totalItemsCount} 
                            itemsPerPage={paginationConfig.itemsPerPage}
                             
                    // itemsPerPage={parseInt(itemsPerPage || CONST.P_ITEMS_LIMIT)}
                    // activePage={parseInt(activePage || 1)} 
                    activePage={paginationConfig.page} 
                    onPageChange={props.pageChange} />
            </div>
            
        </React.Fragment>
    )

}

TableWithPagination.defaultProps = {
    pageChange: null, 
    paginationConfig: {}, 
};
TableWithPagination.propTypes = { 
    // pageChange: PropTypes.fun,///TODO uncomment and fix warning 
    paginationConfig: PropTypes.object, 
    children: PropTypes.element.isRequired
  };

export default TableWithPagination;